import { createReducer, on } from '@ngrx/store';
import * as ProductionActions from './productions.actions';
import { Production } from './productions.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface ProductionsState {
    productions: Production[];
    production: Production | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialProductionsState: ProductionsState = {
    productions: [],
    production: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Productions Reducer
export const productionsReducer = createReducer(
    initialProductionsState,

    // On Load Productions
    on(ProductionActions.loadProductions, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductionActions.loadProductionsSuccess, (state, { productions }) => ({
        ...state,
        isLoading: false,
        productions: productions,
    })),
    on(ProductionActions.loadProductionsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Production
    on(ProductionActions.loadProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductionActions.loadProductionSuccess, (state, { production }) => ({
        ...state,
        isLoading: false,
        production: production,
    })),
    on(ProductionActions.loadProductionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(ProductionActions.createProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductionActions.createProductionSuccess, (state, { production }) => ({
        ...state,
        isLoading: false,
        productions: [...state.productions, production],
    })),
    on(ProductionActions.createProductionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(ProductionActions.updateProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductionActions.updateProductionSuccess, (state, { production }) => ({
        ...state,
        isLoading: false,
        productions: state.productions.map((p) =>
            p.id === production.id ? production : p
        ),
    })),
    on(ProductionActions.updateProductionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(ProductionActions.deleteProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductionActions.deleteProductionSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        productions: state.productions.filter((p) => p.id !== id),
    })),
    on(ProductionActions.deleteProductionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
